import { render } from "./ConsultaProdutoResultado.vue?vue&type=template&id=091cfd52&scoped=true"
import script from "./ConsultaProdutoResultado.vue?vue&type=script&lang=js"
export * from "./ConsultaProdutoResultado.vue?vue&type=script&lang=js"

import "./ConsultaProdutoResultado.vue?vue&type=style&index=0&id=091cfd52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091cfd52"]])

export default __exports__